import { Icon } from "@single-js/common/components/icon/icon";
import { COLORS } from "@single-js/common/sui/color-map";
import { LONG_EM_DASH } from "@single-js/common/util/symbols";
import getTime from "date-fns/get_time";
import qualifiedName from "memsql/qualified-name";
import * as React from "react";
import showDefinitionColumn from "util/show-definition-column";
import ConsoleQueryButton from "view/common/console-query-button";
import { formatBatchTimestamp } from "view/common/models/pipelines";
import "./columns-info.scss";
const formatPipelineState = (state) => {
    let iconColor;
    switch (state) {
        case "Running":
            iconColor = "success";
            break;
        case "Stopped":
            iconColor = "warn";
            break;
        case "Error":
        default:
            iconColor = "error";
            break;
    }
    return (React.createElement("div", { className: "pipeline-state" },
        React.createElement(Icon, { className: "icon", icon: "circle", size: "xs", ...{ [iconColor]: true } }),
        state));
};
const formatLastBatchState = (batch) => {
    if (!batch) {
        return "—";
    }
    let color;
    switch (batch.state) {
        case "Failed":
            color = COLORS["base-red-900"];
            break;
        case "Canceled":
            color = COLORS["base-yellow-900"];
            break;
        default:
            break;
    }
    return React.createElement("span", { style: { color } }, batch.state);
};
const getSourceTypeIcon = (sourceType) => {
    switch (sourceType) {
        case "S3":
            return "s3";
        case "KAFKA":
            return "kafka";
        case "AZURE":
            return "azure";
        case "FS":
            return "filesystem";
        case "HDFS":
            return "hdfs";
        case "PROMETHEUS_EXPORTER":
            return "prometheus";
        default:
            return "question";
    }
};
const PIPELINES_COLUMNS = [
    {
        id: "pipelineName",
        title: "Name",
        formatter: (pipeline) => (React.createElement(React.Fragment, null,
            React.createElement(Icon, { icon: getSourceTypeIcon(pipeline.sourceType), size: "sm", className: "name-icon" }),
            pipeline.pipelineName)),
        getValue: (pipeline) => pipeline.pipelineName,
    },
    {
        id: "databaseName",
        title: "Database Name",
        formatter: (pipeline) => pipeline.databaseName,
        getValue: (pipeline) => pipeline.databaseName,
    },
    {
        id: "pipelineState",
        title: "State",
        formatter: (pipeline) => formatPipelineState(pipeline.state),
        getValue: (pipeline) => pipeline.state,
    },
    {
        id: "pipelineFailedBatches",
        title: "Failed Batches",
        textAlign: "right",
        formatter: (pipeline) => pipeline.numFailedBatches.toString(),
        getValue: (pipeline) => pipeline.numFailedBatches.toNumber(), // PLAT-3189
    },
    {
        id: "pipelineLastBatchState",
        title: "Last Batch State",
        formatter: (pipeline) => formatLastBatchState(pipeline.lastBatch),
        getValue: (pipeline) => pipeline.lastBatch ? pipeline.lastBatch.state : undefined,
    },
    {
        id: "pipelineLastBatchTimestamp",
        title: "Last Batch Time",
        formatter: (pipeline) => pipeline.lastBatch
            ? formatBatchTimestamp(pipeline.lastBatch)
            : LONG_EM_DASH,
        getValue: (pipeline) => {
            if (pipeline.lastBatch && pipeline.lastBatch.timestamp) {
                return getTime(pipeline.lastBatch.timestamp);
            }
        },
    },
    {
        id: "pipelineLastBatchRowsWritten",
        title: "Last Batch Rows Written",
        textAlign: "right",
        formatter: (pipeline) => {
            if (pipeline.lastBatch) {
                return pipeline.lastBatch.rowsWritten === undefined
                    ? LONG_EM_DASH
                    : pipeline.lastBatch.rowsWritten.toString();
            }
            else {
                return LONG_EM_DASH;
            }
        },
        getValue: (pipeline) => pipeline.lastBatch && pipeline.lastBatch.rowsWritten
            ? pipeline.lastBatch.rowsWritten.toNumber()
            : undefined, // PLAT-3189
    },
    showDefinitionColumn({
        formatter: ({ databaseName, pipelineName }) => (React.createElement(ConsoleQueryButton, { tipProps: {
                direction: "sw",
                tooltip: "Get the SHOW CREATE PIPELINE output for this pipeline.",
            }, query: `SHOW CREATE PIPELINE ${qualifiedName({
                databaseName,
                name: pipelineName,
            })} \\G`, category: "schema-explorer", action: "show-create-pipeline" })),
    }),
];
export default PIPELINES_COLUMNS;
